import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
import { CHECKOUT, PRICE, IMAGES } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FinalCtaSection() {
  return <section className="relative overflow-hidden bg-industrial px-5 py-14 sm:px-8 lg:py-18" data-id="element-45" data-mp="3quayxcoxopde">
      <img src={IMAGES.fabrication} alt="" aria-hidden="true" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-25" loading="lazy" data-id="element-46" data-mp="3vs46a91z3pf9" />
      <div aria-hidden="true" className="absolute inset-0 bg-industrial/80" data-id="element-47" data-mp="3348dhffiyhnr" />

      <div className="relative mx-auto max-w-2xl text-center" data-id="element-48" data-mp="3829uzvxay8x4">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} data-id="element-49" data-mp="3cua0e3w55u13">
          <h2 className="font-display text-2xl font-black uppercase leading-tight text-crudo sm:text-3xl lg:text-4xl" data-id="element-50" data-mp="2kcfjbhopyqeg">
            No te quedes solo con las ganas de aprender
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-aluminio sm:text-base" data-id="element-51" data-mp="28dyixewt9vbq">
            Accedé al sistema completo y avanzá paso a paso desde los
            fundamentos hasta contenidos más avanzados de carpintería en
            aluminio.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        delay: 0.06,
        ease: EASE
      }} className="mt-8 rounded-2xl border-2 border-electrico bg-noche p-5 sm:p-7" data-id="element-52" data-mp="1um1uply9k5km">
          <p className="font-display text-sm font-extrabold uppercase tracking-wider text-electrico-light" data-id="element-53" data-mp="1fpb3w12no26m">
            🔥 Super Combo PRO
          </p>
          <p className="mt-2 text-sm text-aluminio" data-id="element-54" data-mp="3a29cmg8piqru">
            6 Tomos + 6 Bonos + 2 Productos PRO
          </p>
          <p className="mt-1 font-display text-xs font-extrabold uppercase tracking-[0.18em] text-crudo sm:text-sm" data-id="element-55" data-mp="18dd7tef8lxxt">
            14 recursos digitales
          </p>

          <p className="mt-4 font-display text-4xl font-black leading-none text-crudo sm:text-5xl" data-id="element-56" data-mp="1d5wkm963op1k">
            {PRICE.pro} <span className="text-base font-bold" data-id="element-57" data-mp="yd2u7spaioi4">ARS</span>
          </p>
          <p className="mt-1.5 text-[0.7rem] font-semibold uppercase tracking-wider text-aluminio/60" data-id="element-58" data-mp="13ea2dsvchppb">
            Pago único
          </p>

          <div className="mt-6" data-id="element-59" data-mp="1w2fook21rmr9">
            <CtaButton href={CHECKOUT.pro} label="Quiero acceder al Super Combo PRO" size="xl" data-id="element-60" data-mp="1w1mm7va4fjex" />
          </div>

          <div className="mt-5 flex justify-center" data-id="element-61" data-mp="1m489o6rbjerw">
            <TrustLine align="center" data-id="element-62" data-mp="1m2os8ctxexoj" />
          </div>
        </motion.div>

        <p className="mt-6 text-xs leading-relaxed text-aluminio/50" data-id="element-63" data-mp="6moowkvceki2">
          ¿Preferís empezar con el Super Combo de {PRICE.combo}?{' '}
          <a href="#ofertas" className="font-semibold text-aluminio/80 underline underline-offset-2 transition-colors duration-150 ease-out hover:text-crudo" data-id="element-64" data-mp="an04hj8ulumo">
            Volver a comparar opciones ↑
          </a>
        </p>
      </div>
    </section>;
}